import { connect } from 'react-redux';

import ReceiptView from '../components/ReceiptView';

const mapActionCreators = {};
const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(ReceiptView);
